import React from 'react';
import {getPaidColor} from '../../../_common/utils/getPaidColor';

export function InspectionOrderPaidColumnFormatter(cellContent) {
  const paidValue = Number(cellContent.paid) || 0;
  const totalPaymentValue = Number(cellContent.totalPayment) || 0;

  const paidPart =
    totalPaymentValue > 0
      ? paidValue / totalPaymentValue
      : 0;

  const paidPartValue =
    paidPart > 0
      ? `${(paidPart * 100).toFixed(2)}%`
      : '';

  return (
    <div
      dir={'ltr'} style={{color: getPaidColor(paidPart)}}
      className="font-weight-bolder font-size-lg text-nowrap"
    >
      {paidPartValue}
    </div>
  );
}